import React from 'react';
import {
    Row,
    Col,
    Form,
    FormGroup,
    Modal,
    ModalHeader,
    ModalFooter,
    Button,
    ModalBody,
    Card,
    CardBody,
    CardTitle
  } from 'reactstrap';
import { connect } from 'react-redux';
import * as loginSelectors from '../store/login/reducer';
import { MdPerson, MdPayment, MdLocalShipping, MdInfo, MdPermContactCalendar } from 'react-icons/lib/md';
/* const formatDate = (date) => {
    if(date !== null){
      return date.replace('/', '-').replace('/', '-').replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
    }
    else{
      return new Date().toDateString()
    }
  } */
class InfoModal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            user: false,
            name_user: '',
            document_user: '',
            email_user: '',
            phone_number_user: '',
            status_name: '',
            method_payment_name: '',
            method_url: '',
            value: '',
            external_order_id: '',
            external_payment_id: '',
            local_created_at: '',
            local_updated_at: '',
            pos_user: false,
            name_pos_user: '',
            document_pos_user: '',
            email_pos_user: '',
            phone_number_pos_user: '',
            events: []
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this)
    }
    handleOnChange(name, value) {
        this.setState({
            [name]: value
        });
    }
    handleInputChange(event) {
        // get target
        const target = event.target;
        // if checkbox or input field
        const value = target.type === 'checkbox' ? target.checked : target.value;
        // get tag name
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    toggle(refresh) {
      this.setState({
        user: false,
        name_user: '',
        document_user: '',
        email_user: '',
        phone_number_user: '',
        status_name: '',
        method_payment_name: '',
        method_url: '',
        value: '',
        external_order_id: '',
        external_payment_id: '',
        local_created_at: '',
        local_updated_at: '',
        pos_user: false,
        name_pos_user: '',
        document_pos_user: '',
        email_pos_user: '',
        phone_number_pos_user: '',
        events: []
      });
      this.props.toggle(refresh);
    }
    componentWillUpdate(nextProps, nextState){
        if(nextProps.visible !== !this.props.visible){
            console.log(nextProps)
        }
        if(nextProps.editing !== this.props.editing){
            if(nextProps.editing !== null){
            var user = nextProps.editing;
                this.setState({
                    user: (user.buyer ? true : false),
                    name_user: (user.buyer ? user.buyer.name : ''),
                    document_user: (user.buyer ? user.buyer.document : ''),
                    email_user: (user.buyer ? user.buyer.email : ''),
                    phone_number_user: (user.buyer ? user.buyer.phone_number : ''),
                    status_name: (user.status ? user.status.name : 'Indisponível'),
                    method_payment_name: (user.method ? user.method.name : 'Indisponível'),
                    method_url: (user.billet_url ? user.billet_url : ''),
                    value: (user.value ? user.value : 'Indisponível'),
                    external_order_id: (user.external_order_id ? user.external_order_id : 'Indisponível'),
                    external_payment_id: (user.external_payment_id ? user.external_payment_id : 'Indisponível'),
                    local_created_at: (user.local_created_at ? user.local_created_at : 'Indisponível'),
                    local_updated_at: (user.local_updated_at ? user.local_updated_at : 'Indisponível'),
                    pos_user: (user.pos_user ? true : false),
                    name_pos_user: (user.pos_user ? user.pos_user.name : ''),
                    document_pos_user: (user.pos_user ? user.pos_user.document : ''),
                    email_pos_user: (user.pos_user ? user.pos_user.email : ''),
                    phone_number_pos_user: (user.pos_user ? user.pos_user.phone_number : ''),
                    events: user.events
                })
            }
        }
    }
    fileSelected = event => {
        try{
          if(event.target.files[0].size < 4000000){
            this.setState({
              file: event.target.files[0]
            })
          }
        }
        catch(ex){
          
        }
      }
    render(){
        const returnColor = (status) => {
            if(status === "CANCELLED"){
                return 'danger'
            }
            else if(status === "IN_ANALYSIS"){
                return 'orange'
            }
            else if(status === "AUTHORIZED"){
                return 'success'
            }
            else if(status === "SETTLED"){
                return 'primary'
            }
            else{
                return 'orange'
            }
        }
        return (
            <Modal size="lg" isOpen={this.props.visible}>
                <ModalHeader>
                    Detalhes
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <CardTitle><MdPerson size={30}/> Comprador</CardTitle>
                                            {this.state.user ? 
                                            <div>
                                                <p><b>Nome:</b> {this.state.name_user}</p>
                                                <p><b>Documento:</b> {this.state.document_user}</p>
                                                <p><b>Email:</b> {this.state.email_user}</p>
                                                <p><b>Telefone:</b> {this.state.phone_number_user}</p>
                                            </div> : <p>Os dados do comprador não estão disponíveis</p>}
                                        </CardBody>
                                    </Card>
                                    <hr/>
                                    <Card>
                                        <CardBody>
                                            <CardTitle><MdPayment size={30}/> Pagamento</CardTitle>
                                            <p><b>Status de Pagamento:</b> {this.state.status_name}</p>
                                            <p><b>Metodo de Pagamento:</b> {this.state.method_payment_name}</p>
                                            {this.state.method_url.length > 0 ? <p><b>Boleto: </b><a target="_blank" href={this.state.method_url}><b>Abrir Boleto</b></a></p> : null}
                                            <p><b>Valor:</b> {this.state.value}</p>
                                            <p><b>ID do pedido externo:</b> {this.state.external_order_id}</p>
                                            <p><b>ID de pagamento externo:</b> {this.state.external_payment_id}</p>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <CardTitle><MdLocalShipping size={30}/> Vendedor</CardTitle>
                                            { this.state.pos_user ? 
                                            <div>
                                                <p><b>Nome:</b> {this.state.name_pos_user}</p>
                                                <p><b>Documento:</b> {this.state.document_pos_user}</p>
                                                <p><b>Email:</b> {this.state.email_pos_user}</p>
                                                <p><b>Telefone:</b> {this.state.phone_number_pos_user}</p>
                                            </div>
                                             : <p>Não possui vendedor</p>}
                                            </CardBody>
                                    </Card>
                                    <hr/>
                                    <Card>
                                        <CardBody>
                                            <CardTitle><MdInfo size={30}/> Outras Informações</CardTitle>
                                            <p><b>Criado em: </b>{this.state.local_created_at}</p>
                                            <p><b>Alterado em: </b>{this.state.local_updated_at}</p>
                                        </CardBody>
                                    </Card>
                                    <hr/>
                                    <Card>
                                        <CardBody>
                                            <CardTitle><MdPermContactCalendar size={30}/> Eventos</CardTitle>
                                                <Row>
                                                {this.state.events.map((p, index) => (
                                                    <Col key={index} lg={6} md={6} sm={6} xs={6} className="mb-3">
                                                        <Card inverse color={returnColor(p.status.moip_status)}>
                                                        <CardBody>
                                                            <CardTitle className="text-capitalize">
                                                                {p.local_updated_at}
                                                            </CardTitle>
                                                                {p.status ? p.status.name : 'Indisponivel'}
                                                        </CardBody>
                                                        </Card>
                                                    </Col>
                                                ))}
                                                </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button outline color="secondary" onClick={() => this.toggle(false)}>OK</Button>
                </ModalFooter>
            </Modal>
        )
    }
}
// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    return {
      user: loginSelectors.getUser(state),
      error: loginSelectors.getErrorLogin(state)
    };
  }
  export default connect(mapStateToProps)(InfoModal);


// WEBPACK FOOTER //
// ./src/components/InfoModal.js